import { render } from "./PaymentTransferPanel.vue?vue&type=template&id=0667df24&scoped=true&ts=true"
import script from "./PaymentTransferPanel.vue?vue&type=script&lang=ts"
export * from "./PaymentTransferPanel.vue?vue&type=script&lang=ts"

import "./PaymentTransferPanel.vue?vue&type=style&index=0&id=0667df24&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0667df24"]])

export default __exports__